import { showErrorToast } from '~/utils/toast-notifications';
import { MutationsCreator } from '@/store/utils';

export default {
  ...MutationsCreator([
    {
      name: 'UPLOAD_POST_IMAGE',
      state: 'uploadPostImage',
    },
  ]),
  UPDATE_POST: (state, payload) => {
    if (state.post) {
      state.post = payload;
    }
  },
  UPDATE_POST_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.post) return;

    const newLikedState = !payload.isLiked;

    state.post.isLiked = newLikedState;

    state.post.likeCount = newLikedState
      ? (state.post.likeCount += 1)
      : (state.post.likeCount -= 1);
  },
  ROLLBACK_POST_LIKE: (state, payload) => {
    if (!state.post) return;

    state.post.isLiked = payload.isLiked;
    state.post.likeCount = payload.likeCount;
  },
  UPDATE_REPLY: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];

        // Reply-related info are not sent back from the API
        const replies = res[index].replies;
        const showLoadMore = res[index].showLoadMore;

        res[index] = payload;
        res[index].replies = replies;
        res[index].showLoadMore = showLoadMore;
        state.replies = res;
      }
    }
  },
  UPDATE_POST_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.replies) return;

    const replyToUpdate = state.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    const newLikeState = !payload.isLiked;

    replyToUpdate.isLiked = newLikeState;

    replyToUpdate.likeCount = newLikeState
      ? (replyToUpdate.likeCount += 1)
      : (replyToUpdate.likeCount -= 1);
  },
  ROLLBACK_POST_REPLY_LIKE: (state, payload) => {
    if (!state.replies) return;

    const replyToUpdate = state.replies.find(
      (r) => r.postId === payload.replyId
    );

    if (!replyToUpdate) return;

    replyToUpdate.isLiked = payload.isLiked;
    replyToUpdate.likeCount = payload.likeCount;
  },
  UPDATE_POST_AFTER_EDIT: (state, post) => {
    if (state.post) {
      if (state.post.replyCount) post.replyCount = state.post.replyCount;
      if (state.replies) post.replies = state.replies;
      state.post = post;
    }
  },
  UPDATE_REPLY_AFTER_EDIT: (state, payload) => {
    const replyIndex = state.replies.findIndex(
      (i) => i.postId === payload.postId
    );
    if (replyIndex !== -1) {
      const reply = state.replies[replyIndex];
      if (reply.replies) payload.data.replies = reply.replies;
      if (reply.replyCount) payload.data.replyCount = reply.replyCount;
      state.replies.splice(replyIndex, 1, payload.data);
    }
  },
  UPDATE_NESTED_REPLY_AFTER_EDIT: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      const nestedIndex = state.replies[replyIndex].replies.findIndex(
        (p) => p.postId === payload.nestedReplyId
      );
      if (nestedIndex !== 1) {
        const nestedReply = state.replies[replyIndex].replies[nestedIndex];
        if (nestedReply.replyCount)
          payload.data.replyCount = nestedReply.replyCount;
        if (nestedReply.replies) payload.data.replies = nestedReply.replies;

        state.replies[replyIndex]?.replies.splice(nestedIndex, 1, payload.data);
      }
    }
  },
  UPDATE_NESTED_REPLY: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      const nestedIndex = state.replies[replyIndex].replies.findIndex(
        (p) => p.postId === payload.nestedReply.postId
      );

      if (replyIndex !== -1 && nestedIndex !== -1) {
        const replies = [...state.replies];
        const nestedReplies = [...replies[replyIndex].replies];

        nestedReplies[nestedIndex] = payload.nestedReply;
        replies[replyIndex].replies = nestedReplies;

        state.replies = replies;
      }
    }
  },
  UPDATE_POST_NESTED_REPLY_LIKE_OPTIMISTIC: (state, payload) => {
    if (!state.replies) return;

    const reply = state.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    const newLikeState = !payload.isLiked;

    nestedReplyToUpdate.isLiked = newLikeState;

    nestedReplyToUpdate.likeCount = newLikeState
      ? (nestedReplyToUpdate.likeCount += 1)
      : (nestedReplyToUpdate.likeCount -= 1);
  },
  ROLLBACK_NESTED_REPLY_LIKE: (state, payload) => {
    if (!state.replies) return;

    const reply = state.replies.find((r) => r.postId === payload.replyId);

    if (!reply) return;

    const nestedReplyToUpdate = reply.replies.find(
      (nr) => nr.postId === payload.nestedReplyId
    );

    if (!nestedReplyToUpdate) return;

    nestedReplyToUpdate.isLiked = payload.isLiked;
    nestedReplyToUpdate.likeCount = payload.likeCount;
  },
  SET_POST: (state, payload) => {
    state.post = payload;
  },
  SET_REPLIES: (state, payload) => {
    state.replies = payload;
  },
  SET_NESTED_REPLIES: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);
      if (index !== -1) {
        const res = [...state.replies];
        res[index].replies = payload.replies;
        state.replies = res;
      }
    }
  },
  APPEND_REPLIES: (state, payload) => {
    state.replies = [...state.replies, ...payload];
  },
  APPEND_NEW_REPLY: (state, payload) => {
    if (state.isLoadFinished) state.replies = [...state.replies, payload];
  },
  APPEND_NESTED_REPLIES: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];

        res[index].replies = [...res[index].replies, ...payload.replies];
        state.replies = res;
      }
    }
  },
  APPEND_NEW_NESTED_REPLY: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);

      if (index !== -1) {
        const res = [...state.replies];
        if (!res[index].replies) res[index].replies = [];

        res[index].replies = [...res[index].replies, payload.post];
        state.replies = res;
      }
    }
  },
  SET_NESTED_REPLY_VIEW_MORE: (state, payload) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === payload.postId);
      if (index !== -1) {
        const res = [...state.replies];
        res[index].showLoadMore = payload.show;
        state.replies = res;
      }
    }
  },
  SET_POST_LOADING: (state, isLoading) => {
    state.postLoading = isLoading;
  },
  SET_REPLIES_LOADING: (state, isLoading) => {
    state.repliesLoading = isLoading;
  },
  SET_NEXT_REPLIES_LOADING: (state, isLoading) => {
    state.nextRepliesLoading = isLoading;
  },
  SET_NESTED_REPLIES_LOADING: (state, isLoading) => {
    state.nextRepliesLoading = isLoading;
  },
  SET_POST_ERROR: (state, error) => {
    state.postError = error;
    showErrorToast(window.$nuxt.$t('error_post_page_post'));
  },
  SET_REPLIES_ERROR: (state, error) => {
    state.repliesError = error;
    showErrorToast(window.$nuxt.$t('error_post_page_replies'));
  },

  INIT_PAGE: (state) => {
    state.post = null;
    state.postLoading = false;
    state.postError = null;
    state.replies = null;
    state.repliesLoading = false;
    state.repliesError = null;
    state.newReplyCount = 0;
    state.isLoadFinished = false;
  },
  INIT_POST: (state) => {
    state.post = null;
    state.postLoading = false;
    state.postError = null;
  },
  INIT_REPLIES: (state) => {
    state.replies = null;
    state.repliesLoading = false;
    state.repliesError = null;
  },
  INCREMENT_POST_REPLYCOUNT: (state) => {
    if (state.post) {
      state.post.replyCount++;
    }
  },
  INCREMENT_REPLY_REPLYCOUNT: (state, postId) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === postId);

      if (index != -1) {
        state.replies[index].replyCount++;
      }
    }
  },
  INCREMENT_NESTED_REPLY_REPLYCOUNT: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      if (replyIndex > -1 && state.replies[replyIndex].replies) {
        const nestedIndex = state.replies[replyIndex].replies.findIndex(
          (p) => p.postId === payload.nestedReplyId
        );

        if (nestedIndex !== -1) {
          const replies = [...state.replies];
          const nestedReplies = [...replies[replyIndex].replies];

          nestedReplies[nestedIndex].replyCount++;
          replies[replyIndex].replies = nestedReplies;

          state.replies = replies;
        }
      }
    }
  },
  INCREMENT_POST_REPOSTCOUNT: (state) => {
    if (state.post) {
      state.post.repostCount++;
    }
  },
  INCREMENT_REPLY_REPOSTCOUNT: (state, postId) => {
    if (state.replies) {
      const index = state.replies.findIndex((e) => e.postId === postId);

      if (index != -1) {
        state.replies[index].repostCount++;
      }
    }
  },
  INCREMENT_NESTED_REPLY_REPOSTCOUNT: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (e) => e.postId === payload.replyId
      );

      if (replyIndex > -1 && state.replies[replyIndex].replies) {
        const nestedIndex = state.replies[replyIndex].replies.findIndex(
          (p) => p.postId === payload.nestedReplyId
        );

        if (nestedIndex !== -1) {
          const replies = [...state.replies];
          const nestedReplies = [...replies[replyIndex].replies];

          nestedReplies[nestedIndex].repostCount++;
          replies[replyIndex].replies = nestedReplies;

          state.replies = replies;
        }
      }
    }
  },
  SET_IS_LOAD_FINISHED: (state, value) => {
    state.isLoadFinished = value;
  },
  SET_POLL: (state, { pollId, pollData }) => {
    state.polls = { ...state.polls, [pollId]: pollData };
  },
  UPDATE_POLL: (state, payload) => {
    if (state.polls[payload.pollId]) {
      state.polls[payload.pollId] = state.polls[payload.pollId].map(
        (option) => {
          if (option.id === payload.id) {
            return { ...option, votes: option.votes + 1 };
          }
          return option;
        }
      );
    }
  },
  DELETE_POST_REPLY_SUCCESS: (state, payload) => {
    if (state.replies) {
      const replyIndex = state.replies.findIndex(
        (r) => r.postId === payload.replyId
      );

      if (replyIndex !== -1) {
        if (state.post) {
          // Decrementing reply count on a post
          state.post.replyCount--;
        }
        state.replies.splice(replyIndex, 1);
      }
    }
  },
  DELETE_POST_REPLY_ERROR: (state, error) => {
    state.deleteUserPost.error = error;
  },
  DELETE_POST_NESTED_REPLY_SUCCESS: (state, payload) => {
    if (state.replies) {
      const reply = state.replies.find((r) => r.postId === payload.replyId);

      if (reply) {
        const nestedReplyIndex = reply.replies.findIndex(
          (nr) => nr.postId === payload.nestedReplyId
        );

        if (nestedReplyIndex !== -1) {
          // Decrementing reply count on a reply
          reply.replyCount--;
          reply.replies.splice(nestedReplyIndex, 1);
        }
      }
    }
  },
  DELETE_POST_NESTED_REPLY_ERROR: (state, error) => {
    state.deleteUserPost.error = error;
  },
};
